import { startTransition, useEffect } from 'react';

function hashChangeHandler() {
  const hash = window.location.hash;
  if (hash) {
    const element = document.getElementById(hash.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

export const withScrollIntoView = (Component) => (props) => {
  useEffect(() => {
    startTransition(() => {
      window.addEventListener('hashchange', hashChangeHandler);
    });

    return () => {
      window.removeEventListener('hashchange', hashChangeHandler);
    };
  }, []);

  return <Component {...props} />;
};
